<template>
  <v-dialog v-model="visible" persistent>
    <v-card class="elevation-4 mx-auto" :style="{ width: '100%', maxWidth: computedMaxWidth }" rounded="lg">
      <Form ref="form" :onAction="onAction">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <component v-if="computedIcon" :is="computedIcon" class="title-icon me-2" :style="{ color: computedTitleColor }" />
            <span :style="{ color: computedTitleColor }">{{ title }}</span>
          </div>
          <ButtonBase iconStyle iconType="cancel" color="grey" :disabled="loading" @click="onCancel" type="button" />
        </v-card-title>

        <v-card-text class="pa-6 pt-2">
          <slot name="content"></slot>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="d-flex justify-center justify-sm-end ma-2">
          <ButtonBase :buttonText="cancelButtonText" iconType="cancel" :disabled="loading" @click="onCancel" type="button" />
          <ButtonBase :buttonText="actionButtonText" iconType="check" :loading="loading" variant="flat" type="submit" />
        </v-card-actions>
      </Form>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from "@/components/forms/Form.vue";
import ButtonBase from "@/components/buttons/ButtonBase.vue";
import { getIcon } from "@/components/utils/utils";
import { gtKey } from "@/i18n/gt";

export default {
  name: "DialogBase",

  components: {
    Form,
    ButtonBase,
  },

  props: {
    type: {
      type: String,
      default: "default",
      validator: (value) => ["default", "warning", "delete"].includes(value),
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["md", "lg", "xl"].includes(value),
    },
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Function,
      default: null,
    },
    iconType: {
      type: String,
      default: null,
    },
    actionButtonText: {
      type: String,
      default: gtKey("Aktion"),
    },
    onAction: {
      type: Function,
      required: true,
    },
    cancelButtonText: {
      type: String,
      default: gtKey("Abbrechen"),
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  computed: {
    computedIcon() {
      return getIcon(this.icon, this.iconType);
    },

    computedMaxWidth() {
      const widths = {
        md: "500px",
        lg: "750px",
        xl: "960px",
      };
      return widths[this.size] || "500px";
    },

    computedTitleColor() {
      const colors = {
        delete: "var(--error-color)",
        warning: "var(--warning-color)",
        default: "var(--primary-color)",
      };
      return colors[this.type];
    },

    computedButtonColor() {
      const colors = {
        delete: "error",
        warning: "warning",
        default: "primary",
      };
      return colors[this.type];
    },
  },

  methods: {
    openDialog() {
      this.visible = true;
    },

    closeDialog() {
      this.visible = false;
    },

    async validate() {
      return await this.$refs.form.validateForm();
    },

    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.title-icon {
  width: 24px;
  height: 24px;
  stroke-width: 2;
}

:deep(.v-col) {
  padding-top: 4px;
  padding-bottom: 12px;
}
</style>
